import Pages from 'pages/Pages';
import React from 'react';

function App() {
  return (
    <div>
      <Pages />
    </div>
  );
}

export default App;
